import { types } from "../types/types";

export const setScheduleDashboard = (data) => ({
    type: types.loadAppointmentsDashboard,
    payload: data,
});

export const clearDashboard = () => ({
    type: types.clearDashboardReducer,
  });